module.exports = __webpack_public_path__ + "static/media/81lsyvNemKL._AC_SL1500_.38a4d5e8.jpg";